// eslint-disable-next-line no-unused-vars
import React, { useEffect, useRef } from 'react';

let lockCount = 0;

const lockScroll = () => {
  lockCount++;
  if (lockCount === 1 && typeof document !== 'undefined') {
    document.documentElement.classList.add('noScroll');
    document.body.classList.add('noScroll');
  }
};

const unlockScroll = () => {
  lockCount = Math.max(0, lockCount - 1);
  if (lockCount === 0 && typeof document !== 'undefined') {
    document.documentElement.classList.remove('noScroll');
    document.body.classList.remove('noScroll');
  }
};

const useScrollLock = shouldLock => {
  const isLocked = useRef(false);

  useEffect(() => {
    if (shouldLock && !isLocked.current) {
      lockScroll();
      isLocked.current = true;
    } else if (!shouldLock && isLocked.current) {
      unlockScroll();
      isLocked.current = false;
    }

    // clean on unmount
    return () => {
      if (isLocked.current) {
        unlockScroll();
        isLocked.current = false;
      }
    };
  }, [shouldLock]);
};

export default useScrollLock;
